var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "word",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.596,
    height: 82.443,
    viewBox: "0 0 78.596 82.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(9.451 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_54",
    "data-name": "Subtraction 54",
    d: "M60.9,82.443H8.244A8.254,8.254,0,0,1,0,74.2V64.832H28.486a5.006,5.006,0,0,0,5-5V21.313a5.006,5.006,0,0,0-5-5H0V8.244A8.253,8.253,0,0,1,8.244,0H47.87L69.145,21.275V74.2A8.254,8.254,0,0,1,60.9,82.443ZM44.424,53.372v5.153h19.4V53.372Zm0-9.373v5.153h19.4V44Zm0-9.374v5.153h19.4V34.626Zm.8-29.274V23.988h18.6Z",
    transform: "translate(0 0)",
    fill: "#d6d6d6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M32.2,36.613H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H32.2a5.006,5.006,0,0,1,5,5V31.613A5.005,5.005,0,0,1,32.2,36.613ZM18.473,17.019l3.14,13.428h5.863L32.452,6.883h-5.6l-2.69,14.775L20.888,6.883h-4.8L12.868,21.659,10.178,6.883H4.558L9.55,30.447H15.4l3.075-13.428Z",
    transform: "translate(0 22.199)",
    fill: "#3f9dd6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.0802748e9f615f4b87a37796cc6bc3dd.svg";
export { ForwardRef as ReactComponent };